import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { RecoilRoot } from "recoil"

import { initializeEventTracker } from "lib/eventTracker"
import logger from "lib/logger"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

import "normalize.css"

initializeEventTracker()

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <Router>
        <App />
      </Router>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    logger("react app mounted")
  },
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
